import axios from "axios";


export const getEventById = (id) => {
  try {
    return axios.get("/api/eventos/"+id);
  } catch (error) {
    console.error(error)
  }
};

// Post In and get Attende Details
export const postIn = (event_id) => {
  try {
    return axios.post("/api/eventos/"+event_id+"/in");
  } catch (error) {
    console.error(error)
  }
};

// Post Out and get Attende Details
export const postOut = (event_id) => {
    try {
      return axios.post("/api/eventos/"+event_id+"/out");
    } catch (error) {
      console.error(error)
    }
  };
